import React from "react"
import NavBar from "../navbar/navbar.js"
import Footer from "../footers/Footer"
import MetaDecorator from "../meta/MetaDecorator.js"
import useSeoMetadata from "./staticMetaData.js"
import { Script } from "gatsby"
import Referral from "../banners/referral"
export default function HeaderFooter({
	children,
	title,
	description,
	imageUrl,
	imageAlt,
	keywords,
	location,
}) {
	const seoData = useSeoMetadata()

	return (
		<>
			<div className="flex flex-col min-h-screen justify-between">
				<Script
					async
					type="text/javascript"
					src="https://app.termly.io/embed.min.js"
					data-auto-block="on"
					data-website-uuid="6d04fc43-f94d-4c93-af34-81fa46bf7e28"
				></Script>
				<MetaDecorator
					title={title ? title : seoData.title}
					description={description ? description : seoData.metaDescription.metaDescription}
					imageAlt={imageAlt ? imageAlt : seoData.image.description}
					imageUrl={`https:${imageUrl ? imageUrl : seoData.image.file.url}`}
					keywords={keywords ? keywords : seoData.keywords}
					location={location}
				/>
				<Referral />
				<NavBar />
				{children}

				<Footer />
			</div>
		</>
	)
}
